import { FormattedMessage, useIntl } from 'react-intl'

import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  isBedbank: boolean
  offerPage: boolean
  finePrintUrl: string
  onFinePrint: () => void
}

function TaxAndFeesText({ isBedbank, offerPage, finePrintUrl, onFinePrint }: Props) {
  const intl = useIntl()
  const finePrintLabel = isBedbank
    ? intl.formatMessage({
        id: '_L1th1zwqPJ8ekqlzX1P',
        defaultMessage: 'Terms and Conditions',
        description: 'Link label for bedbank terms and conditions in the price details breakdown',
      })
    : intl.formatMessage({
        id: 'K2TKq8-yH-vKprvj-diM',
        defaultMessage: '‘Fine Print’',
        description: 'Link label for fine print section in the price details breakdown',
      })
  const finePrintLink = offerPage ?
      <TextLink weight="regular" onClick={onFinePrint}>{finePrintLabel}</TextLink> :
      <TextLink weight="regular" to={finePrintUrl}>{finePrintLabel}</TextLink>

  if (isBedbank) {
    return (<BodyText variant="medium" as="p">
      <FormattedMessage
        id="K4VLsedWLUrAUUVcNePo"
        defaultMessage="The taxes are tax recovery charges paid to vendors (e.g., hotels); for details, please see our Terms of Use. Service fees are retained as compensation in servicing your booking and may include fees charged by vendors. For more details, please see the {finePrintLink}."
        description="Bedbank tax and fees legal disclaimer text on the hotel page"
        values={{ finePrintLink }}
      />
    </BodyText>)
  }

  return (
    <BodyText variant="medium">
      <FormattedMessage
        id="Jc7jSS51y-231T68x_bB"
        defaultMessage="This charge includes estimated amounts the travel service provider pays for their taxes, and/or taxes that we pay, to taxing authorities on your booking (including but not limited to sales, occupancy, and value-added tax). This amount may also include any amounts charged to us for resort fees, cleaning fees, and other fees and/or a fee we, the website you booked on, retain as part of the compensation for our and/or their services, which varies based on factors such as location, the amount, and how you booked. Please refer to the {finePrintLink} for any additional costs payable directly to the property."
        description="Standard tax and fees legal disclaimer text in the booking flow"
        values={{ finePrintLink }}
      />
    </BodyText>
  )
}

export default TaxAndFeesText
